import CasinoList from "./list";
import {Link, useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import associateServices from "../../services";
import {useSelector} from "react-redux";
import SvgIcon from "../../components/svg-icon";
import {useTranslation} from "react-i18next";
import stringHelper from "../../helpers/string-helper";

const CasinoCategory = () => {

    const navigate = useNavigate()
    const {type} = useParams()

    const {t, i18n} = useTranslation()
    const currentLanguage = i18n.language; // Get the current language

    const {exclusiveGameTypes} = useSelector(state => state.dataReducer)
    const [providersList, setProvidersList] = useState([])

    useEffect(() => {
        setProvidersList([])
        associateServices.getGameProvidersGroup({type}).then(handleProviders)
    }, [type])

    const handleProviders = response => setProvidersList(response?.data || [])


    return (
        <>
            <div className="section section--first">
                <div className="container">
                    <div className="col-12">
                        <ul className="tags">
                            {
                                exclusiveGameTypes?.map(gameType =>
                                    <li
                                        className={`${gameType.key === type ? 'active' : ''}`}
                                        key={gameType.key}>
                                        <Link
                                            to={stringHelper.getLocalizedPath(currentLanguage, gameType.path)}>
                                            <SvgIcon id={gameType.icon}/>
                                            {t(`sidebar.${gameType.key}`)}
                                        </Link>
                                    </li>
                                )
                            }
                        </ul>
                    </div>
                </div>
            </div>

            <div className="section section--last pt-24">
                <div className="container">
                    <CasinoList {...{type, providersList}}/>
                </div>
            </div>
        </>


    )

}

export default CasinoCategory
